import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

const cls = "bg-black/40 border-white/15";

function HoursInput({ value, onChange, testid }) {
  const set = (i, k, v) => onChange(value.map((h, j) => (j === i ? { ...h, [k]: v } : h)));
  return (
    <div className="space-y-2 rounded-sm border border-white/10 p-3" data-testid={testid}>
      {value.map((h, i) => (
        <div key={h.day} className="grid grid-cols-[90px_1fr_1fr_auto] items-center gap-2 text-sm">
          <span className="text-white/80">{h.day}</span>
          <Input type="time" value={h.open} disabled={h.closed} onChange={(e) => set(i, "open", e.target.value)} className={cls} data-testid={`${testid}-open-${i}`} />
          <Input type="time" value={h.close} disabled={h.closed} onChange={(e) => set(i, "close", e.target.value)} className={cls} data-testid={`${testid}-close-${i}`} />
          <label className="flex items-center gap-1 text-xs text-white/60"><input type="checkbox" checked={h.closed} onChange={(e) => set(i, "closed", e.target.checked)} /> Closed</label>
        </div>
      ))}
      <p className="text-xs text-white/40">A closing time earlier than the opening time means it closes after midnight (e.g. 05:00 to 02:00).</p>
    </div>
  );
}

export function FieldInput({ field, value, onChange, testid }) {
  const { type = "text", label } = field;
  let input;
  if (type === "textarea") input = <Textarea rows={4} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className={cls} data-testid={testid} />;
  else if (type === "number") input = <Input type="number" value={value ?? ""} onChange={(e) => onChange(e.target.value === "" ? null : Number(e.target.value))} className={cls} data-testid={testid} />;
  else if (type === "list") input = <Textarea rows={3} value={(value || []).join("\n")} onChange={(e) => onChange(e.target.value.split("\n"))} onBlur={() => onChange((value || []).map((s) => s.trim()).filter(Boolean))} className={cls} data-testid={testid} />;
  else if (type === "bool") input = <div><Switch checked={!!value} onCheckedChange={onChange} data-testid={testid} /></div>;
  else if (type === "select") input = (
    <select value={value} onChange={(e) => onChange(e.target.value)} className="h-10 w-full rounded-md border border-white/15 bg-black/40 px-3 text-sm" data-testid={testid}>
      {field.options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  );
  else if (type === "hours") input = <HoursInput value={value} onChange={onChange} testid={testid} />;
  else input = <Input value={value ?? ""} onChange={(e) => onChange(e.target.value)} className={cls} data-testid={testid} />;
  const wide = ["textarea", "list", "hours"].includes(type);
  return (
    <div className={`space-y-1.5 ${wide ? "sm:col-span-2" : ""}`}>
      <Label className="text-xs uppercase tracking-wider text-white/55">{label}</Label>
      {input}
    </div>
  );
}
